import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getPages, useFlowDispatch } from "../hooks/df";
import { checkFieldVisible, getFieldConfig, isPageValid, } from "../services/dfUtils";
import ProgressBar from "./ProgressBar";
import ProgressCircle from "./ProgressCircle";
import Question from "./Question";
import CheckboxSpanish from "./fieldType/CheckboxSpanish";
import { isNullOrUndefined, saveToDfStorage } from "../services/helperLib";
import { refinanceTypes } from "../services/interfaces";
import { pages } from "./../configs/pages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons";
import Loading from "./Loading";
import { useState, useEffect, useRef } from "react";
import ReactGA from 'react-ga4';
import { createSubmitHandler } from "../services/leadService";
function oneTrustGaEnabled() {
    if (typeof window === "undefined")
        return false;
    var otGroups = window.OnetrustActiveGroups || "";
    return otGroups.includes("C0002");
}
var element = (typeof window !== 'undefined' && window.location.pathname.toLocaleLowerCase().includes('/lp/df/dscr')) ? '.flow' : '#main';
export default function Page(_a) {
    var _b, _c;
    var flow = _a.flow;
    var _d = useState(false), submitting = _d[0], setSubmitting = _d[1];
    var _e = useState(false), needsSpanishSpeakingLO = _e[0], setNeedsSpanishSpeakingLO = _e[1];
    var pageCollection = flow.config.pageCollection || pages;
    var parentPage = flow.config.parentPageCollection;
    var currentPage = pageCollection === null || pageCollection === void 0 ? void 0 : pageCollection[flow.currentStep];
    var pageRef = useRef(null);
    // Add a ref to track first render
    var isFirstRender = useRef(true);
    useEffect(function () {
        var _a;
        if (currentPage && oneTrustGaEnabled()) {
            ReactGA.send({ hitType: 'pageview', page: "/".concat(flow.config.path, "/").concat(((_a = currentPage.title) === null || _a === void 0 ? void 0 : _a.replace(/\s+/g, '-').toLowerCase()) || '') });
        }
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        scrollTo(element); //check if PO wants the form content instead '.flow'
    }, [currentPage, flow.config.path, element]);
    if (currentPage == null)
        return _jsx(Loading, {});
    var dispatch = useFlowDispatch();
    if (!dispatch) {
        console.error("Flow dispatch is not available");
        return;
    }
    var rootEl = typeof document !== "undefined" ? document.getElementById("root") : null;
    var layoutType = ((_c = (_b = rootEl === null || rootEl === void 0 ? void 0 : rootEl.dataset) === null || _b === void 0 ? void 0 : _b.layout) === null || _c === void 0 ? void 0 : _c.toLowerCase()) || "";
    var isLeftNav = layoutType === "leftnav";
    var hasSpanishCheckbox = getPages(flow.config).some(function (pageId) { var _a; return ((_a = pageCollection[pageId]) === null || _a === void 0 ? void 0 : _a.includeNeedsSpanishSpeakingLOCheckbox) === true; });
    var showSpanishDisclosures = flow.isLastStep === true &&
        hasSpanishCheckbox &&
        needsSpanishSpeakingLO &&
        !!(parentPage === null || parentPage === void 0 ? void 0 : parentPage.formDisclosuresSpanish);
    var percentCompleted = function () {
        var allPages = getPages(flow.config);
        var total = allPages.length;
        if (total <= 1)
            return 0;
        return Math.round(((flow.currentStepIndex + 1) / total) * 100);
    };
    var sendGa = function (category, action, label) {
        oneTrustGaEnabled() &&
            ReactGA.event({
                category: category,
                action: action,
                label: label || "Step ".concat(flow.currentStep, " - ").concat(currentPage.title || '')
            });
    };
    var showBackButton = function () { return !flow.isFirstStep; };
    var showNextButton = function () {
        if (currentPage.questions.length === 1 &&
            getFieldConfig(currentPage.questions[0]).type === "radio")
            return false;
        var show = currentPage.questions.find(function (q) {
            getFieldConfig(q).inputType === "text";
        });
        return isNullOrUndefined(show) && !flow.isLastStep;
    };
    var showSkipButton = function () {
        return !isNullOrUndefined(currentPage.skipLink) && !flow.isLastStep;
    };
    var showSkipText = function () {
        var skipCondition = currentPage.skipLink;
        return skipCondition != undefined ? skipCondition[1] : "Skip";
    };
    var visibleQuestions = function () { return currentPage.questions.filter(function (id) {
        var field = getFieldConfig(id);
        return checkFieldVisible(field);
    }); };
    var checkPage = function () {
        var visibleData = Object.fromEntries(Object.entries(flow.formData).filter(function (_a) {
            var key = _a[0];
            return visibleQuestions().includes(key);
        }));
        return isPageValid(visibleData, visibleQuestions());
    };
    var backHandler = function () {
        sendGa('cta_click', 'Back Button Clicked');
        dispatch({ type: "Back" });
    };
    var nextHandler = function () {
        sendGa('cta_click', 'Next Button Clicked');
        dispatch({ type: "Next" });
    };
    var resetPageFields = function () {
        var formData = {};
        visibleQuestions().forEach(function (fieldId) {
            var fieldConfig = getFieldConfig(fieldId);
            formData[fieldId] = {
                config: fieldConfig,
                fieldValue: getEmptyValue(fieldConfig),
            };
        });
        return formData;
    };
    var getEmptyValue = function (fieldConfig) {
        return fieldConfig.inputType === "currency" ? 0 : ""; //send 0 or empty for now. Future update for bool or other type as needed
    };
    var skipHandler = function () {
        sendGa('cta_click', 'Skip Button Clicked');
        var resetFields = resetPageFields();
        dispatch({ type: "Skip", formData: resetFields });
    };
    var switchFlowHandler = function () {
        var _a;
        var _b;
        var currentVal = (_b = flow.formData) === null || _b === void 0 ? void 0 : _b.loanPurpose.fieldValue;
        if (!currentVal)
            return;
        var selectedVal = refinanceTypes.includes(currentVal === null || currentVal === void 0 ? void 0 : currentVal.toLowerCase()) ? "purchase" : "refinance";
        saveToDfStorage("loanPurpose", selectedVal);
        var fieldConfig = getFieldConfig("loanPurpose");
        dispatch({
            type: "SwitchFlow",
            formData: (_a = {},
                _a["loanPurpose"] = {
                    config: fieldConfig,
                    fieldValue: selectedVal,
                    isValid: true,
                },
                _a),
        });
    };
    var displaySwitchText = "";
    var showSwitchFlow = function () {
        var _a, _b, _c, _d;
        var show = (Object.keys(((_a = flow === null || flow === void 0 ? void 0 : flow.config) === null || _a === void 0 ? void 0 : _a.subFlows) || {}).length > 1) && currentPage.showLoanOptionSwitch == null ?
            flow.currentStepIndex == 1 : currentPage.showLoanOptionSwitch;
        if (!flow.formData.loanPurpose || !((_b = flow.formData) === null || _b === void 0 ? void 0 : _b.loanPurpose.fieldValue))
            return false;
        if (show) {
            displaySwitchText = refinanceTypes.includes((_d = (_c = flow.formData) === null || _c === void 0 ? void 0 : _c.loanPurpose.fieldValue) === null || _d === void 0 ? void 0 : _d.toLowerCase()) ? "Purchasing Instead?" : "Refinance Home Instead?";
        }
        return show;
    };
    var submitHandler = createSubmitHandler({
        flow: flow,
        dispatch: dispatch,
        setSubmitting: setSubmitting,
        checkPage: checkPage,
        submitting: submitting,
        needsSpanishSpeakingLO: needsSpanishSpeakingLO
    });
    return (_jsxs("div", { className: "page", id: flow.currentStep.split('_')[1] || flow.currentStep, ref: pageRef, children: [isLeftNav && !flow.isFirstStep && (_jsx(ProgressBar, { percentCompleted: percentCompleted() })), _jsxs("div", { className: "questions-block", children: [_jsxs("div", { className: "question-text", children: [currentPage.title && (flow.isFirstStep ? (_jsx("h1", { className: "question-title", children: currentPage.title })) : (_jsx("h3", { className: "question-title", children: currentPage.title }))), currentPage.subtext && (_jsx("p", { className: "question-desc", dangerouslySetInnerHTML: { __html: currentPage.subtext || "" } }))] }), _jsxs("div", { className: "questions-wrapper", children: [_jsxs("div", { className: "questions", children: [currentPage.questions
                                        .filter(function (fieldId) {
                                        var fieldConfig = getFieldConfig(fieldId);
                                        return checkFieldVisible(fieldConfig);
                                    })
                                        .map(function (fieldId) {
                                        var fieldConfig = getFieldConfig(fieldId);
                                        if (!fieldConfig) {
                                            console.error("Field config not found for id: ".concat(fieldId));
                                            return null;
                                        }
                                        return _jsx(Question, { fieldId: fieldId }, fieldId);
                                    }), _jsx(CheckboxSpanish, { show: currentPage.includeNeedsSpanishSpeakingLOCheckbox, text: currentPage.customNeedsSpanishSpeakingLOText, value: needsSpanishSpeakingLO, onChange: setNeedsSpanishSpeakingLO }), currentPage.disclosure &&
                                        !(flow.isLastStep &&
                                            (currentPage.hideDisclosure === true ||
                                                currentPage.questions.some(function (q) { var _a, _b; return ((_b = (_a = flow.config.questionCollection) === null || _a === void 0 ? void 0 : _a[q]) === null || _b === void 0 ? void 0 : _b.hideDisclosure) === true; }))) && (_jsx("div", { className: "question-disclosures", children: _jsx("p", { children: currentPage.disclosure }) })), showSkipButton() && (_jsx("button", { className: "link-skip", onClick: skipHandler, children: showSkipText() })), showSwitchFlow() && (_jsx("div", { children: _jsx("button", { className: "link-skip", onClick: function () { return switchFlowHandler(); }, children: displaySwitchText }) }))] }), showNextButton() && checkPage().valid && (_jsx("button", { className: "btn-next", onClick: nextHandler, disabled: !checkPage().valid, children: "Next" })), flow.isLastStep && (_jsxs("div", { className: "submit-wrapper", children: [checkPage().valid && (_jsx("button", { className: "btn-submit", onClick: submitHandler, disabled: submitting, children: submitting ? "Submitting..." : "Submit" })), submitting && (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "60", height: "60", viewBox: "0 0 100 100", className: "submit-spinner", children: Array.from({ length: 12 }).map(function (_, i) {
                                            var rotate = i * 30;
                                            var begin = (i - 11) / 12;
                                            return (_jsx("g", { transform: "rotate(".concat(rotate, " 50 50)"), children: _jsx("circle", { cx: "50", cy: "26", r: "3.5", fill: "#3b6ccf", children: _jsx("animate", { attributeName: "opacity", values: "1;0", keyTimes: "0;1", dur: "3.2s", begin: "".concat(begin, "s"), repeatCount: "indefinite" }) }) }, i));
                                        }) }))] }))] }), showBackButton() && (_jsxs("button", { className: "link-back".concat(flow.isLastStep ? " last-step" : ""), onClick: backHandler, children: [_jsx(FontAwesomeIcon, { icon: faChevronLeft }), "Back"] })), showSpanishDisclosures && (_jsx("div", { className: "form-disclosures", dangerouslySetInnerHTML: { __html: parentPage.formDisclosuresSpanish } })), flow.isLastStep && !!(parentPage === null || parentPage === void 0 ? void 0 : parentPage.formDisclosures) && (_jsx("div", { className: "form-disclosures", dangerouslySetInnerHTML: { __html: parentPage.formDisclosures } })), !isLeftNav && !flow.isFirstStep && (_jsx(ProgressCircle, { percentCompleted: percentCompleted(), isLastStep: flow.isLastStep }))] })] }));
}
var scrollTo = function (selector) {
    var element = document.querySelector(selector);
    if (!element)
        return;
    var fixedHeader = document.querySelector('#hd.fixed-top');
    var offsetPos = fixedHeader ? element.getBoundingClientRect().top + window.pageYOffset - fixedHeader.offsetHeight : element.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
        top: offsetPos,
        behavior: 'smooth'
    });
};
